// extracted by mini-css-extract-plugin
export default {"drawer":"Popover_drawer__K634O","popover":"Popover_popover__CluWb","arrow":"Popover_arrow__0TcYp","close":"Popover_close__WT48B"};